import ReactGA from 'react-ga';

import config from '../../config/config';
import { sendErrorToSentry } from '../../logging';
import { VALIDATE_CREDENTIALS_SUCCESS, SIGNUP_SUCCESS } from '../../actionCreators/authActions';
import { CREATE_NEW_CUSTOMER_ORDER_SUCCESS } from '../../actionCreators/paymentActions';
import { ADD_SCRIBE_SUCCESS } from '../../actionCreators/scribeActions';
import { SAVE_AUDIO } from '../../actionCreators/scribeActions';

export const getGATracker = () => {
  const debug = !(config.ENVIRONMENT === 'prod' || config.ENVIRONMENT === 'test');

  const options = {
    debug
  };

  ReactGA.initialize(config.GA_ACCOUNT_ID, options);

  // Init FastSpring Integration
  ReactGA.ga('require', 'linker');
  ReactGA.ga('linker:autoLink', ['sparkol.onfastspring.com', 'sparkol.test.onfastspring.com']);

  return ReactGA;
};

// most of the code uses GA so export that as the default
export default getGATracker();

export const getGAWhitelist = action => {
  return {
    ADD_SCRIBE_SUCCESS: {
      category: 'Project',
      action: 'CREATE_SCRIBE'
    },
    DELETE_SCRIBE_SUCCESS: {
      category: 'Project',
      action: 'DELETE_SCRIBE'
    },
    SORT_SCRIBES: {
      category: 'Project',
      action: 'SORT_SCRIBES',
      label: action?.sortOrder
    },
    TOGGLE_MOBILE_NAV: {
      category: 'Project',
      action: 'TOGGLE_MOBILE_NAV'
    },
    FILTER_SCRIBES: {
      category: 'Project',
      action: 'FILTER_SCRIBES',
      label: action?.scope
    },
    EDITOR_UNDO: {
      category: 'Project',
      action: 'UNDO'
    },
    EDITOR_REDO: {
      category: 'Project',
      action: 'REDO'
    },
    EDITOR_PASTE: {
      category: 'Project',
      action: 'PASTE'
    },
    EDITOR_COPY: {
      category: 'Project',
      action: action?.asCut === true ? 'CUT' : 'COPY'
    },
    MOVE_ELEMENT_ON_TIMELINE: {
      category: 'Project',
      action: 'REORDER_ELEMENTS'
    },
    DELETE_USER_IMAGE_REQUESTED: {
      category: 'Image',
      action: 'DELETE_USER_IMAGE_REQUESTED'
    },
    DELETE_USER_IMAGE_FAILURE: {
      category: 'Image',
      action: 'DELETE_USER_IMAGE_FAILURE'
    },
    DELETE_USER_IMAGE_SUCCESS: {
      category: 'Image',
      action: 'DELETE_USER_IMAGE_SUCCESS'
    },
    ADD_USER_IMAGE_TO_SCRIBE: {
      category: 'Project',
      action: 'ADD_IMAGE_TO_SCRIBE'
    },
    LOGOUT: {
      category: 'User',
      action: 'LOGOUT'
    },
    VALIDATE_CREDENTIALS_REQUESTED: {
      category: 'User',
      action: 'LOGIN'
    },
    VALIDATE_CREDENTIALS_SUCCESS: {
      category: 'User',
      action: 'LOGIN_SUCCESS'
    },
    VALIDATE_CREDENTIALS_FAILED: {
      category: 'User',
      action: 'LOGIN_FAILED',
      label: action?.error?.message
    },
    SIGNUP_REQUESTED: {
      category: 'User',
      action: 'CREATE_ACCOUNT_SUBMIT'
    },
    SIGNUP_FAILED: {
      category: 'User',
      action: 'CREATE_ACCOUNT_FAILED',
      label: action?.error?.err
    },
    SIGNUP_SUCCESS: {
      category: 'User',
      action: 'CREATE_ACCOUNT_SUCCESS'
    },
    CREATE_NEW_CUSTOMER_ORDER_SUCCESS: {
      category: 'Upgrade',
      action: 'PAYMENT_SUCCESS'
    },
    CREATE_NEW_CUSTOMER_ORDER_FAILURE: {
      category: 'Upgrade',
      action: 'PAYMENT_FAILURE'
    }
  };
};

/**
 * Track HS Events
 *
 * We're using the REST API tracker for this. The JS one just
 * doesn't seem to work.
 *
 * @see https://developers.hubspot.com/docs/methods/enterprise_events/http_api
 */
const hsTrackRestAPIUrl = 'https://track.hubspot.com/v1/event/';

export const getHSTracker = () => {
  return {
    event: (action, email = '') => {
      fetch(`${hsTrackRestAPIUrl}?_a=${config.HUBSPOT_ID}&_n=${action.eventId}&email=${email}`, {
        mode: 'no-cors'
      }).catch(err => {
        console.error(err);
        sendErrorToSentry(err);
      });
    }
  };
};

export const getHSWhitelist = action => {
  return {
    [VALIDATE_CREDENTIALS_SUCCESS]: {
      eventId: '000009012193', // 'Scribely Login'
      email: action?.user?.email
    },
    [ADD_SCRIBE_SUCCESS]: {
      eventId: '000009028695' // 'Scribely Scribe Created'
    },
    [SIGNUP_SUCCESS]: {
      eventId: '000009039734', // 'Scribely Account Created'
      email: action.email
    },
    [CREATE_NEW_CUSTOMER_ORDER_SUCCESS]: {
      eventId: '000009147796' // User upgrades
    },
    [SAVE_AUDIO]: {
      eventId: '000009400057'
    }
  };
};
